import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataAgentIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4 26C4.54667 26 5 25.5467 5 25V22H6C6.54667 22 7 21.5467 7 21C7 20.4533 6.54667 20 6 20H4C3.45333 20 3 20.4533 3 21V25C3 25.5467 3.45333 26 4 26Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 25V17H12C12.5467 17 13 16.5467 13 16C13 15.4533 12.5467 15 12 15H10C9.45333 15 9 15.4533 9 16V25C9 25.5467 9.45333 26 10 26C10.5467 26 11 25.5467 11 25Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 25V8H21C21.5467 8 22 7.54667 22 7C22 6.45333 21.5467 6 21 6H16C15.4533 6 15 6.45333 15 7V25C15 25.5467 15.4533 26 16 26C16.5467 26 17 25.5467 17 25Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 10C21.4533 10 21 10.4533 21 11V25C21 25.5467 21.4533 26 22 26C22.5467 26 23 25.5467 23 25V12H27V25C27 25.5467 27.4533 26 28 26C28.5467 26 29 25.5467 29 25V11C29 10.4533 28.5467 10 28 10H22Z",
      fill: "currentColor"
    })]
  });
};
export default DataAgentIcon;